/* Maison Avela - плавно появяване на секциите при скрол.
   Класът, който скрива секциите, се добавя само от този скрипт.
   Ако скриптът не се зареди, страницата се вижда нормално. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = [];
    var children = main.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains('shopify-section')) sections.push(children[i]);
    }
    if (!sections.length) return;

    document.documentElement.classList.add('ma-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          entries[i].target.classList.add('ma-reveal--in');
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }
    );

    for (var j = 0; j < sections.length; j++) {
      sections[j].classList.add('ma-reveal');
      if (j === 0) {
        sections[j].classList.add('ma-reveal--in');
      } else {
        observer.observe(sections[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
